module.exports = "<div style=display:flex;flex-direction:column;justify-content:center;align-items:center> <h1> THIS VIEW IS NO LONGER IN USE</h1> <h2><a href=manager/performance-assessment/round-management/ ><strong> Take me to the new view</strong></a></h2> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-round/salary-round.html
 ** module id = 225
 ** module chunks = 0
 **/